var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { staticClass: "toolbar", attrs: { color: "primary", dark: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "d-flex", attrs: { cols: "12", md: "6" } },
                [
                  _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("mdi-file-document-outline")
                  ]),
                  _c("div", { staticClass: "ml-3" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.title))]),
                    _c("h3", [_vm._v(_vm._s(_vm.titulo.ds_nosso_numero))])
                  ])
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end",
                  attrs: { "data-html2canvas-ignore": "" }
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "white--text",
                                      style: _vm.retornarValorInstrumentoProtesto(
                                        _vm.titulo,
                                        "style"
                                      ),
                                      attrs: { fab: "", dark: "", small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.verificarFuncaoInstrumentos(
                                            _vm.titulo
                                          )
                                        }
                                      }
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.retornarValorInstrumentoProtesto(
                                            _vm.titulo,
                                            "icon"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.retornarValorInstrumentoProtesto(
                                _vm.titulo,
                                "tooltip"
                              )
                            ) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _vm.problemaMensageria
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g({ attrs: { icon: "" } }, on),
                                      [
                                        _c("v-icon", { attrs: { large: "" } }, [
                                          _vm._v("mdi-email-alert-outline")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4045106228
                          )
                        },
                        [
                          _c("span", [
                            _vm._v("Há problema de mensageria para este título")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.copyLink()
                                      }
                                    }
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { large: "" } }, [
                                    _vm._v("mdi-link")
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_vm._v(" Copiar link deste título ")]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g({ attrs: { icon: "" } }, on),
                                [
                                  !_vm.loadingTituloImpressao
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: { large: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.historicoImpressao(
                                                _vm.titulo
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("mdi-printer-outline")]
                                      )
                                    : _c("v-progress-circular", {
                                        attrs: { dark: "", indeterminate: "" }
                                      })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Imprimir este título")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: _vm.colorSnackbar,
              mensagemSnackbar: _vm.mensagemSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }